import React from 'react';
import { AsyncAutocomplete } from './AsyncAutocomplete';
export var HttpAutocomplete = function HttpAutocomplete(props) {
  return React.createElement(AsyncAutocomplete, Object.assign({}, props));
};